function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.45 64.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.83,1.73C3.32,6.87.94,16.65,2.14,25.1c1.23,8.69,1.02,16.33-.59,20.89-4.19,11.88.48,20.58,9.58,17.86,3.04-.91,4.85-.9,8.07.07,3.7,1.11,4.43,1.03,6.75-.69,1.43-1.06,3.17-3.64,3.87-5.72,1.41-4.21.56-8.62-3.86-20.02-2.05-5.27-2.33-7.76-2.37-20.5-.02-7.97-.4-15.06-.85-15.75-.92-1.43-4.69-1.71-4.69-.35,0,.52-1.56.53-3.75.02C9.36-.24,9.59-.27,7.83,1.73",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.24,11.87c-.32,6.69,0,10.19,1.32,14.15,2.18,6.57,2.79,5.6,4.9-7.77.89-5.63,2.12-11.48,2.73-13l1.11-2.77.85,3c.49,1.72.44,6.66-.11,11.56-.84,7.43-.71,9.51,1.02,15.74,1.09,3.95,1.99,7.29,1.99,7.44s-3.98.26-8.84.26H6.37s-1.3-10.21-1.3-10.21c-.71-5.61-1.05-12.02-.76-14.23.56-4.2,4.38-13.06,5.63-13.06.4,0,.53,4,.29,8.89",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73,7.73c-.32,2.06-.88,6.1-1.25,8.98-1.01,7.86-2.75,5.34-2.21-3.2.48-7.43,1.13-9.53,2.97-9.53.67,0,.85,1.39.49,3.75",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.49,44.32c2.65,1.94,3.28,10.38,1.08,14.62-1.59,3.07-1.93,3.24-5.36,2.55-4.48-.89-6.5-.89-11.7,0-3.09.53-4.35.33-5.35-.88-1.82-2.19-1.57-12.27.38-15.25,1.45-2.21,2.2-2.38,10.35-2.38,5.74,0,9.42.46,10.61,1.33",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg26);
export default __webpack_public_path__ + "static/media/26.bae478c962ecf4e4c532be6bfc5798a5.svg";
export { ForwardRef as ReactComponent };